import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

const initialState: NotificationReduxState = {
    orders: [],
    excludedOrders: {},
};

const notificationSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        setNotificationOrders(state, action: PayloadAction<CashBoxOrderSummary[] | undefined>) {
            const notificationOrders = action.payload || [];
            state.orders = notificationOrders;

            const updatedExcludedOrderIdsInfo = {...state.excludedOrders};
            Object.keys(updatedExcludedOrderIdsInfo).forEach(key => {
                if (
                    !(notificationOrders || []).find(order => order.id === Number(key))
                ) {
                    delete updatedExcludedOrderIdsInfo[key];
                }
            });
            state.excludedOrders = updatedExcludedOrderIdsInfo;
        },
        addToFilteredNotificationOrders(state, action: PayloadAction<Record<string, CashBoxExcludedNotificationOrderInfo>>) {
            state.excludedOrders = {
                ...state.excludedOrders,
                ...action.payload,  // New excluded order IDs info.
            };
        },
        setFilteredNotificationOrders(state, action: PayloadAction<number[] | number | undefined>) {
            const itemIds =
                Array.isArray(action.payload)
                    ? action.payload :
                typeof action.payload === "number"
                    ? [action.payload]
                    : [];
            const excludedOrders = (state.orders || []).filter(ord => !itemIds.includes(Number(ord?.id)));

            state.orders = excludedOrders;
        },
        clearNotificationOrders(state) {
            state.orders = [];
        },
    },
});

export const {
    setNotificationOrders,
    addToFilteredNotificationOrders,
    clearNotificationOrders,
} = notificationSlice.actions;

export default notificationSlice.reducer;
